import { AuthService } from "../services/auth.service";
import { GoogleSearchService } from "../services/googlesearch.service";
import { PortalStatsService } from "../services/portal-stats.service";
import { ProductService } from "../services/product.service";
import { SubscriberService } from "../services/subscriber.service";
import { LeadsService } from "../services/leads.service";
import { TiktokService } from "../services/tiktok.service";

const SERVICES = {
  AuthService,
  GoogleSearchService,
  PortalStatsService,
  ProductService,
  SubscriberService,
  LeadsService,
  TiktokService,
};

export class ServiceFactory {
  static createInstance({ type, data }) {
    const servicesCreator = SERVICES[type];
    const service = servicesCreator ? new servicesCreator(data) : null;
    return service;
  }
}
